import { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function AdminLayout({ children, navigate, active, title }) {
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const NAV = [
    { section:"Main" },
    { key:"dashboard",   icon:"📊", label:"Dashboard" },
    { key:"dashboard",   icon:"📋", label:"All Applications" },
    { section:"Manage" },
    { key:"agents",      icon:"👥", label:"Agents" },
    { key:"air-tickets", icon:"✈️", label:"Air Tickets" },
    { key:"hotels",      icon:"🏨", label:"Hotels" },
    { key:"visas",       icon:"🛂", label:"Visas" },
    { section:"System" },
    { key:"settings",    icon:"⚙️", label:"Settings" },
    { key:"reports",     icon:"📈", label:"Reports" },
  ];

  return (
    <div style={{display:"flex",minHeight:"100vh",background:"#f0f3f9",fontFamily:"'DM Sans',sans-serif"}}>
      <style>{`
        .sb-link{display:flex;align-items:center;gap:11px;padding:11px 20px;font-size:13px;cursor:pointer;text-decoration:none;border-left:3px solid transparent;transition:all 0.2s;}
        .sb-link:hover{background:rgba(74,127,181,0.12) !important;color:#fff !important;border-left-color:#4a7fb5 !important;}
        .admin-sidebar{transition:transform 0.25s ease;}
        .hamburger-btn{display:none;}
        .admin-overlay{display:none;}
        @media (max-width:900px){
          .admin-sidebar{transform:translateX(-100%);}
          .admin-sidebar.open{transform:translateX(0);}
          .admin-main{margin-left:0 !important;}
          .hamburger-btn{display:flex !important;}
          .admin-overlay.open{display:block;position:fixed;inset:0;background:rgba(10,22,40,0.5);z-index:99;}
          .topbar-title{font-size:16px !important;}
          .topbar-badge{display:none !important;}
          .admin-content-pad{padding:16px !important;}
        }
      `}</style>

      {/* MOBILE OVERLAY */}
      <div className={`admin-overlay ${mobileOpen ? "open" : ""}`} onClick={()=>setMobileOpen(false)}/>

      {/* SIDEBAR */}
      <aside className={`admin-sidebar ${mobileOpen ? "open" : ""}`} style={{width:240,background:"#0d1f3c",display:"flex",flexDirection:"column",position:"fixed",top:0,left:0,height:"100vh",zIndex:100,borderRight:"1px solid rgba(74,127,181,0.15)"}}>

        {/* LOGO */}
        <div style={{padding:"16px 20px",borderBottom:"1px solid rgba(255,255,255,0.08)",display:"flex",alignItems:"center",justifyContent:"center",minHeight:92}}>
          <img src="/logo-small.png" alt="AIHOVI B2B"
            style={{height:64,objectFit:"contain",filter:"drop-shadow(0 2px 8px rgba(0,0,0,0.4))"}}
            onError={e=>{
              e.target.style.display="none";
              e.target.nextSibling.style.display="flex";
            }}
          />
          {/* Fallback if logo fails */}
          <div style={{display:"none",alignItems:"center",gap:8}}>
            <div style={{width:36,height:36,background:"linear-gradient(135deg,#4a7fb5,#d4736a)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Cormorant Garamond',serif",fontWeight:700,fontSize:15,color:"#fff",flexShrink:0}}>AI</div>
            <div>
              <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,color:"#fff",letterSpacing:2,lineHeight:1}}>AIHOVI</div>
              <div style={{fontSize:8,letterSpacing:3,color:"#4a7fb5",textTransform:"uppercase"}}>Admin Panel</div>
            </div>
          </div>
        </div>

        {/* NAV */}
        <nav style={{flex:1,padding:"10px 0",overflowY:"auto"}}>
          {NAV.map((item,i) => item.section ? (
            <div key={i} style={{fontSize:10,letterSpacing:2,textTransform:"uppercase",color:"#8a9bb5",padding:"8px 20px",marginTop:8}}>{item.section}</div>
          ) : (
            <a key={i} onClick={()=>{navigate(item.key); setMobileOpen(false);}} className="sb-link"
              style={{color:active===item.key?"#fff":"rgba(255,255,255,0.6)",borderLeftColor:active===item.key?"#4a7fb5":"transparent",background:active===item.key?"rgba(74,127,181,0.2)":"transparent"}}>
              <span style={{fontSize:15,width:18,textAlign:"center",flexShrink:0}}>{item.icon}</span>
              {item.label}
            </a>
          ))}
        </nav>

        {/* FOOTER */}
        <div style={{padding:"14px 18px",borderTop:"1px solid rgba(255,255,255,0.08)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:11}}>
            <div style={{width:32,height:32,background:"linear-gradient(135deg,#4a7fb5,#d4736a)",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>👑</div>
            <div style={{overflow:"hidden"}}>
              <div style={{fontSize:10,color:"#4a7fb5",letterSpacing:1,textTransform:"uppercase"}}>Administrator</div>
              <div style={{fontSize:12,color:"#fff",fontWeight:500,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{user?.name}</div>
            </div>
          </div>
          <button onClick={logout} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:7,background:"rgba(212,115,106,0.15)",border:"1px solid rgba(212,115,106,0.35)",color:"#e8a09a",padding:"9px",borderRadius:8,fontSize:12,cursor:"pointer",fontWeight:500,fontFamily:"'DM Sans',sans-serif"}}>
            🚪 Sign Out
          </button>
          <div style={{textAlign:"center",fontSize:10,color:"rgba(255,255,255,0.3)",marginTop:12}}>
            Developed by <a href="https://www.websignx.com" target="_blank" rel="noreferrer" style={{color:"rgba(255,255,255,0.45)",textDecoration:"none",fontWeight:600}}>www.websignx.com</a>
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <div className="admin-main" style={{marginLeft:240,flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
        {/* TOPBAR */}
        <div style={{background:"#fff",borderBottom:"1px solid #e4e9f0",padding:"0 30px",height:60,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:50,boxShadow:"0 1px 4px rgba(10,22,40,0.04)",gap:10}}>
          <div style={{display:"flex",alignItems:"center",gap:12,minWidth:0}}>
            <button className="hamburger-btn" onClick={()=>setMobileOpen(o=>!o)} style={{alignItems:"center",justifyContent:"center",width:34,height:34,background:"#f6f8fc",border:"1px solid #e4e9f0",borderRadius:8,fontSize:16,cursor:"pointer",flexShrink:0}}>☰</button>
            <img src="/logo-small.png" alt="AIHOVI" style={{height:42,objectFit:"contain",flexShrink:0}} onError={e=>e.target.style.display="none"}/>
            <div style={{width:1,height:28,background:"#e4e9f0",flexShrink:0}}/>
            <span className="topbar-title" style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,fontWeight:600,color:"#0d1f3c",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{title}</span>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
            <span className="topbar-badge" style={{background:"#f6f8fc",border:"1px solid #e4e9f0",padding:"5px 12px",borderRadius:8,fontSize:12,color:"#6b7a90"}}>👤 {user?.name}</span>
            <span className="topbar-badge" style={{background:"#f6f8fc",border:"1px solid #e4e9f0",padding:"5px 12px",borderRadius:8,fontSize:12,color:"#6b7a90"}}>🌐 airhotelvisa.com</span>
            <button onClick={logout} style={{padding:"6px 14px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",flexShrink:0}}>Sign Out</button>
          </div>
        </div>

        <div className="admin-content-pad" style={{padding:"26px 30px",overflowX:"hidden"}}>{children}</div>
      </div>
    </div>
  );
}
